import { useQuery } from '@apollo/client'
import { getUserByIdQuery, getUserFilesQuery, getUserNotesQuery, exportUserNotesQuery } from 'gql/user'

export const useGetUserById = (_id: string) => {
  const { data, error, loading, refetch } = useQuery(getUserByIdQuery, {
    variables: { _id },
  })

  return {
    user: data?.getUserById || {},
    loading,
    error,
    refetch,
  }
}

export const useGetUserNotes = (userId: string) => {
  const { data, error, loading, refetch } = useQuery(getUserNotesQuery, {
    variables: { userId },
  })

  return {
    notes: data?.getUserNotes?.notes || [],
    loading,
    error,
    refetch,
  }
}

export const useGetUserFiles = (userId: string) => {
  const { data, error, loading, refetch } = useQuery(getUserFilesQuery, {
    variables: { userId },
  })

  return {
    data: data?.getUserFiles?.files || [],
    loading,
    error,
    refetch,
  }
}

export const useExportUserNotes = (userId: string) => {
  const { data, error, loading, refetch } = useQuery(exportUserNotesQuery, {
    variables: { userId },
    skip: true, // Skip automatic execution, only run when refetch is called
  })

  return {
    exportData: data?.exportUserNotes || null,
    loading,
    error,
    refetch,
  }
}
